export interface IContractionCounter {
    startTime: undefined | Date
    endTime: undefined | Date
    contractionLength: undefined | string
    frequencyLength: undefined | string
}

export function formatCounterTime(time: number) {
    const totalHours = Math.floor(time / 100 / 60 / 60)
    const totalMinutes = Math.floor((time / 100 / 60) % 60)
    const totaleSeconds = Math.floor((time / 100) % 60)
    return `${totalHours.toString().padStart(2, "0")}:${totalMinutes
        .toString()
        .padStart(2, "0")}:${totaleSeconds.toString().padStart(2, "0")}`
}

export function formatCurrentTime(currentTime: Date | undefined) {
    if (currentTime !== undefined) {
        const date = new Date(currentTime)
        const hours = date.getHours().toString().padStart(2, "0")
        const minutes = date.getMinutes().toString().padStart(2, "0")
        const seconds = date.getSeconds().toString().padStart(2, "0")
        return `${hours}:${minutes}:${seconds}`
    }
    return ""
}

export function calculateContractionLength(
    startTime: Date | undefined,
    endTime: Date | undefined
) {
    if (startTime && endTime) {
        const startHours = startTime.getHours()
        const endHours = endTime.getHours()
        const startMinutes = startTime.getMinutes()
        const endMinutes = endTime.getMinutes()
        const startSeconds = startTime.getSeconds()
        const endSeconds = endTime.getSeconds()

        const hours = Math.abs(Number(endHours) - Number(startHours))
        const minutes = Math.abs(Number(endMinutes) - Number(startMinutes))
        const seconds = Math.abs(Number(endSeconds) - Number(startSeconds))

        const formattedTime = `${hours.toString().padStart(2, "0")}:${minutes
            .toString()
            .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`
        return formattedTime
    }
}

export function calculateFrequency(
    contractionArray: IContractionCounter[],
    startTime: Date | undefined
) {
    if (contractionArray && contractionArray.length > 0) {
        const previousStartTime = contractionArray[0].startTime
        const currentStartTime = startTime
        if (previousStartTime && currentStartTime) {
            const hours = Math.abs(
                currentStartTime.getHours() - previousStartTime.getHours()
            )
            const minutes = Math.abs(
                currentStartTime.getMinutes() - previousStartTime.getMinutes()
            )
            const seconds = Math.abs(
                currentStartTime.getSeconds() - previousStartTime.getSeconds()
            )

            const formattedTime = `${hours
                .toString()
                .padStart(2, "0")}:${minutes
                .toString()
                .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`

            return formattedTime
        }
    } else return " -- : -- : --"
}

export function printResult() {
    const result = document.getElementById("resultlist")?.outerHTML
    const w = window.open()
    if (w) {
        w.document.write(result ?? "")
        w.print()
        w.close()
    }
}
